// Plan features data
export const planFeatures = {
  basic: {
    name: "Basic",
    description: "Perfect plan to offer online shopping and delivery for your existing customers.",
    features: [
      {
        text: "Branded website",
        tooltip: "Get your store online and ready for shopping.",
      },
      {
        text: "Plug & play delivery system",
        tooltip: "Just set up your menu, and we take care of the rest. From online shopping to getting the products to the customer.",
      },
      {
        text: "ID verification for all customers",
        tooltip: "Saucey Direct takes care of compliance for you. We'll verify customers' IDs both before ordering and at the time of delivery.",
        useSpan: true,
      },
      {
        text: "Live inventory management",
        tooltip: "Get everything you have in-store onto your online menu, with live updates throughout the partnership.",
      },
      {
        text: "Analytics & reporting",
        tooltip: "Get insights into your store's performance with Saucey Direct.",
      },
    ],
  },
  growth: {
    name: "Growth",
    description: "Grow your business by reaching new customers and increasing sales. Make your stores the talk of the town with the help of our marketing expert.",
    badge: "Most Popular",
    features: [
      {
        text: "Everything included in Basic Plan",
      },
      {
        text: "Complimentary SEO Boost Add-on",
      },
      {
        text: "Two-way sync",
        tooltip: "Integrate your POS system with Saucey Direct.\n*Not all POS systems supported.",
        tooltipPosition: "bottom",
      },
      {
        text: "Customized marketing plans",
        tooltip: "Our marketing team will custom tailor marketing plans for your business and help you align your marketing and sales goals.",
        tooltipPosition: "left",
      },
    ],
  },
};

